// Importing options
import { createComponents } from "./create-components";
import { createPalette } from "./create-palette";
// ----------------------------------------------------------------------
export const createOptions = () => {
    return {
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1440,
            },
        },
        components: createComponents(),
        palette: createPalette(),
    };
};
